import type { SeriesSummaryDto } from '@vmt/shared';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useMaps } from '../hooks/data';
import { FORMAT_LABEL, formatRelative } from '../lib/format';
import { StatusBadge } from './ui/Badge';

export function SeriesCard({ series }: { series: SeriesSummaryDto }) {
  const { lookup } = useMaps();
  const firstMap = series.mapIds[0] ? lookup.get(series.mapIds[0]) : undefined;
  const target = series.status === 'veto' ? `/series/${series.id}/veto` : `/series/${series.id}`;
  return (
    <Link
      to={target}
      className="clip-corner group relative block overflow-hidden border border-ink-700/60 bg-ink-900 transition hover:border-ink-500"
    >
      {firstMap?.listViewIconUrl && (
        <img
          src={firstMap.listViewIconUrl}
          alt=""
          className="absolute inset-0 size-full object-cover opacity-15 transition group-hover:opacity-25"
          loading="lazy"
        />
      )}
      <div className="relative p-4">
        <div className="mb-3 flex items-center justify-between gap-2 text-xs text-ink-400">
          <span className="font-display font-bold tracking-wider uppercase">
            {FORMAT_LABEL[series.format]}
          </span>
          <StatusBadge status={series.status} />
        </div>
        <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
          <span
            className={clsx(
              'truncate font-display text-lg font-bold uppercase text-team-a',
              series.winner === 'b' && 'opacity-60',
            )}
          >
            {series.teamAName}
          </span>
          <span className="font-display text-2xl font-bold tabular-nums">
            <span className={series.winner === 'a' ? 'text-bone' : 'text-ink-300'}>
              {series.winsA}
            </span>
            <span className="mx-1 text-ink-500">:</span>
            <span className={series.winner === 'b' ? 'text-bone' : 'text-ink-300'}>
              {series.winsB}
            </span>
          </span>
          <span
            className={clsx(
              'truncate text-right font-display text-lg font-bold uppercase text-team-b',
              series.winner === 'a' && 'opacity-60',
            )}
          >
            {series.teamBName}
          </span>
        </div>
        <div className="mt-3 flex items-center justify-between gap-2 text-xs text-ink-400">
          <span className="truncate">
            {series.mapIds.map((id) => lookup.get(id)?.name ?? '?').join(' · ') ||
              'Maps nach dem Veto'}
          </span>
          <span className="shrink-0">{formatRelative(series.finishedAt ?? series.createdAt)}</span>
        </div>
      </div>
    </Link>
  );
}
